<template>
	<div class="ratio-tiles">
		<v-card v-for="tile in tiles" :key="tile.key" class="ratio-tiles__tile" flat border>
			<span class="ratio-tiles__label">
				<v-icon size="small">{{ tile.icon }}</v-icon>
				{{ tile.label }}
			</span>
			<span class="ratio-tiles__value">{{ tile.display }}</span>
		</v-card>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import { formatNumber, formatValue, formatWeight, formatPricePerKg } from '@/utils/core/format';

const props = defineProps({
	ratios: { type: Object, required: true },
	showValue: { type: Boolean, default: true },
	showWeight: { type: Boolean, default: true },
});

const t = useTranslator();

const tiles = computed(() => {
	const list = [
		{ key: 'orderCount', icon: 'shopping_cart', label: t('OrderCount'), display: formatNumber(props.ratios.orderCount) },
		{ key: 'productsPerOrder', icon: 'inventory_2', label: t('ProductsPerOrder'), display: formatNumber(props.ratios.productsPerOrder, { decimals: 1 }) },
	];

	if (props.showValue) list.push({ key: 'valuePerOrder', icon: 'paid', label: t('ValuePerOrder'), display: formatValue(props.ratios.valuePerOrder) });
	if (props.showWeight) list.push({ key: 'weightPerOrder', icon: 'scale', label: t('WeightPerOrder'), display: formatWeight(props.ratios.weightPerOrder) });
	if (props.showValue && props.showWeight) list.push({ key: 'pricePerKg', icon: 'sell', label: t('PricePerKg'), display: formatPricePerKg(props.ratios.pricePerKg) });

	return list;
});
</script>

<style scoped lang="scss">
@use '@/styles/variables' as *;

.ratio-tiles {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
	gap: 16px;

	&__tile {
		display: flex;
		gap: 8px;
		padding: 16px;
		min-width: 0;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}

	&__label {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: $font-size-small;
		color: rgba(var(--v-theme-on-surface), 0.68);
	}

	&__value {
		font-size: $font-size-extra-large !important;
		font-weight: 700;
		line-height: 1.1;
		min-width: 120px;
	}
}
</style>
